import { useQuery } from "@tanstack/react-query";
import { RQueryOptions, useCurrentChainId } from "@looksrare/utils";
import { WatchlistCollectionSearchResult } from "types/graphql";
import { getWatchlistCollectionSearchResults } from "utils/graphql";
import { CollectionHitProps } from "./useAlgoliaTrendingCollections";

/**
 * Hits algolia API with a provided search term.
 * Initially intended for a very basic collection search for our add-to-watchlist modal
 */
export const useAlgoliaCollectionIndexSearch = (
  term: string,
  options?: RQueryOptions<WatchlistCollectionSearchResult[]>
) => {
  const currentChainId = useCurrentChainId();
  return useQuery({
    queryKey: ["algolia", "indices", "collections", term],
    queryFn: async () => {
      const res: Response = await fetch(`/api/algolia/indices/collections/${term}?chainId=${currentChainId}`);
      const hits: CollectionHitProps[] = await res.json();
      const addresses = hits.map((hit) => hit.address);
      const collections = await getWatchlistCollectionSearchResults(addresses);
      return collections;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
